import { Redux } from '../..'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GygEonTargets, GygEonTargetsPayload, GygEonTargetsQueryOptions } from '@/src/types/apps/gygEonTargets'

interface EonTargetsInitialState {
  targets: GygEonTargets | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: EonTargetsInitialState = {
  targets: null,
  loading: false,
  success: null,
  error: null
}

interface EonTargetsResponse {
  data: GygEonTargets
}

export const getEonTargetsInTwoDates = createAsyncThunk<EonTargetsResponse, GygEonTargetsQueryOptions, Redux>(
  'gygEonTargets/getEonTargetsInTwoDates',
  async (gygEonTargetsQueryOptions, { extra }) => {
    const { restaurantId, startDate, endDate } = gygEonTargetsQueryOptions

    const { data: responseData } = await extra.httpClient.get(`restaurants/${restaurantId}/eon-targets/latest`, {
      params: {
        startDate,
        endDate
      }
    })

    return responseData
  }
)

export const saveEonTargets = createAsyncThunk<void, GygEonTargetsPayload, Redux>(
  'gygEonTargets/saveEonTargets',
  async (gygEonTargetsPayload, { extra }) => {
    const { restaurantId, ...payload } = gygEonTargetsPayload

    await extra.httpClient.post(`restaurants/${restaurantId}/eon-targets`, payload)
  }
)

const gygEonTargetsSlice = createSlice({
  name: 'gygEonTargets',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getEonTargetsInTwoDates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getEonTargetsInTwoDates.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.targets = action.payload.data
      })
      .addCase(getEonTargetsInTwoDates.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch eon goals targets'
      })
      .addCase(saveEonTargets.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(saveEonTargets.fulfilled, state => {
        state.loading = false
        state.success = 'Eon goals targets saved successfully'
        state.error = null
      })
      .addCase(saveEonTargets.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to save eon goals targets'
      })
  }
})

export default gygEonTargetsSlice.reducer
